import { CartType } from "@cappelendamm/e-commerce-services";

export function getTargetCartType(
  pathname: string,
  orgId: string | null | undefined,
  activeSchool?: string | null,
): CartType {
  if (pathname.startsWith("/vurderingseksemplar"))
    return CartType.EVALUATION_COPY;
  if (orgId || activeSchool) return CartType.ORGANIZATION;
  return CartType.SHOP;
}
